/**
 * Missile - Base class for all missile types
 * Handles position, velocity, trail rendering, and lifecycle.
 */

export class Missile {
  constructor({ x, y, targetX, targetY, speed, color = '#ffffff', trailColor = '#888888' }) {
    this.x = x;
    this.y = y;
    this.targetX = targetX;
    this.targetY = targetY;
    this.speed = speed;
    this.color = color;
    this.trailColor = trailColor;
    this.alive = true;
    this.trail = [{ x, y }];

    // Calculate velocity toward target
    const dx = targetX - x;
    const dy = targetY - y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    this.vx = (dx / dist) * speed;
    this.vy = (dy / dist) * speed;
    this.totalDist = dist;
    this.traveled = 0;
  }

  update(dt) {
    if (!this.alive) return;

    this.x += this.vx * dt;
    this.y += this.vy * dt;
    this.traveled += this.speed * dt;

    // Add to trail
    this.trail.push({ x: this.x, y: this.y });
    if (this.trail.length > 30) {
      this.trail.shift();
    }

    // Check if reached target
    if (this.traveled >= this.totalDist) {
      this.x = this.targetX;
      this.y = this.targetY;
      this.alive = false;
    }
  }

  render(ctx) {
    if (!this.alive && this.trail.length === 0) return;

    // Draw trail without expensive shadowBlur (performance optimization)
    if (this.trail.length > 1) {
      ctx.save();
      ctx.shadowBlur = 0;

      for (let i = 1; i < this.trail.length; i++) {
        const t = i / this.trail.length; // 0 at tail, 1 at head
        ctx.strokeStyle = this.trailColor;
        ctx.globalAlpha = t * 0.7;
        ctx.lineWidth = 0.5 + t * 1.5;
        ctx.beginPath();
        ctx.moveTo(this.trail[i - 1].x, this.trail[i - 1].y);
        ctx.lineTo(this.trail[i].x, this.trail[i].y);
        ctx.stroke();
      }
      ctx.restore();
    }

    // Draw missile head with glow (only the head gets shadowBlur)
    if (this.alive) {
      ctx.save();
      ctx.shadowColor = this.color;
      ctx.shadowBlur = 8;
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, 2.5, 0, Math.PI * 2);
      ctx.fill();

      // Bright inner core
      ctx.shadowBlur = 0;
      ctx.fillStyle = '#ffffff';
      ctx.globalAlpha = 1;
      ctx.beginPath();
      ctx.arc(this.x, this.y, 1, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
  }
}
